import React from "react";
import './Banner.css'
const Banner =(props) =>{
    return(
        <section>
            <div id="chackprice-banner"> 
                <div id="borderonbanner">
                    <h2 id="heading3">On-road price</h2>
                    <input type="text" placeholder="Search Make and Model" id="makemodelfinalprice"/>
                    <div id="loc-2">
                        <select  id="selectloc-2">
                            <option>--Select--</option>
                            <option>B-Road,Jodhpur</option>
                            <option>C-Road,Jodhpur</option>
                            <option>Ratanada</option>
                            <option>Jaljog Chok</option>
                            <option>Chandni Market</option>
                            <option>Mandore</option>
                        </select>
                    </div>
                    <div class="d-grid gap-3 col-3 mx-auto w-75 ms-3 mt-3">
                        <button type="button" class="btn  bg-danger text-white vv ">On-Road Price</button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Banner;